import {EllipsisVerticalIcon, MoveIcon} from "lucide-react";
import {ButtonType} from "components/common/Button.component";
import {ICON_SIZE} from "components/common/constants";
import {MenuButton} from "components/common/menu/MenuButton.component";
import {MenuItem} from "components/common/menu/MenuItem.component";
import {MenuSeparator} from "components/common/menu/MenuSeparator.component";
import {useTranslation} from "components/translations/useTranslation";
import {DropdownPosition} from "types/gaiaComponents/dropdownButton.types";
import type {ModuleMenuProps} from "types/moduleMenu";

/**
 * The options menu at the right of a module header on the redesigned task details page: a ghost
 * icon button that opens the module's context menu. Every module gets "Rearrange modules" first,
 * then, under a separator, any actions of its own passed as MenuItem children.
 * Rearranging is not built yet, so its item is shown disabled.
 */
export const ModuleMenu = ({children, dataCy}: ModuleMenuProps) => {
    const {translate} = useTranslation();

    return (
        <MenuButton buttonType={ButtonType.GHOST}
                    icon={<EllipsisVerticalIcon size={ICON_SIZE.MEDIUM} aria-hidden="true"/>}
                    ariaLabel={translate("taskDetail.moduleOptions")}
                    title={translate("taskDetail.moduleOptions")}
                    position={DropdownPosition.BOTTOM_RIGHT}
                    className="module-menu"
                    dataCy={dataCy}>
            <MenuItem label={translate("taskDetail.rearrangeModules")}
                      icon={MoveIcon}
                      isDisabled
                      dataCy={dataCy && `${dataCy}.rearrangeModules`}/>
            {children && <>
                <MenuSeparator/>
                {children}
            </>}
        </MenuButton>
    );
};

export default ModuleMenu;
